/* eslint-disable react/no-unused-prop-types */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable prefer-template, arrow-body-style */
import React, { useRef } from 'react';
import { Editor as TinymceEditor } from '@tinymce/tinymce-react';
import { FormControl } from '@mui/material';
import ElementUtils from '../../utils';
import '../editor.css';
import { EditorProps } from '../types';

type ProgressFn = (percent: number) => void;

interface BlobInfo {
  id: () => string;
  name: () => string;
  filename: () => string;
  blob: () => Blob;
  base64: () => string;
  blobUri: () => string;
  uri: () => string | undefined;
}

function EditorInline(props: EditorProps) {
  const {
    onChange,
    value,
    error,
    disabled,
    placeholder,
  } = props;
  const editorRef = useRef<TinymceEditor>(null);

  // const handleImageUpload = (blobInfo: BlobInfo, progress: ProgressFn): Promise<string> => {
  //   return new Promise((resolve, reject) => {
  //     const xhr = new XMLHttpRequest();
  //     xhr.open("POST", "http://localhost:8000/server.php", true);

  //     const formData = new FormData();
  //     formData.append("file", blobInfo.blob(), blobInfo.filename());
  //     //console.log(blobInfo.filename())

  //     xhr.upload.onprogress = (e) => {
  //       progress((e.loaded / e.total) * 100);
  //       if (progress && typeof progress === "function") {
  //         const percent = 0;
  //         progress(percent);
  //       }
  //     };

  //     xhr.onload = () => {
  //       if (xhr.status === 403) {
  //         reject({ message: "HTTP Error: " + xhr.status, remove: true });
  //         return;
  //       }

  //       if (xhr.status < 200 || xhr.status >= 300) {
  //         reject("HTTP Error: " + xhr.status);
  //         return;
  //       }

  //       const json = JSON.parse(xhr.responseText);

  //       if (!json || typeof json.location != "string") {
  //         reject("Invalid JSON: " + xhr.responseText);
  //         return;
  //       }

  //       resolve(json.location);
  //     };

  //     xhr.send(formData);
  //   });
  // };

  return (
    <FormControl className="w-full h-full" component="fieldset" variant="standard">
      <input id="my-file" type="file" name="my-file" style={{ display: 'none' }} />
      <TinymceEditor
        tinymceScriptSrc={`${process.env.PUBLIC_URL}/tinymce/tinymce.min.js`}
        ref={editorRef}
        disabled={disabled}
        value={value}
        onEditorChange={(e) => {
          if (onChange) {
            onChange(e, editorRef.current?.editor?.isDirty());
          }
        }}
        init={{
          placeholder: placeholder || 'Type here...',
          object_resizing: false,
          menubar: false,
          inline: true,
          convert_urls: false,
          visual: false,
          plugins: ['link', 'lists', 'autolink', 'image'],
          toolbar: [
            'undo redo | bold italic underline | blocks fontfamily fontsize | forecolor backcolor',
            'alignleft aligncenter alignright alignjustify | numlist bullist outdent indent | blockquote image',
          ],
          file_picker_types: 'image',
          file_picker_callback: (cb, val, meta) => {
            const input = document.createElement('input');
            input.setAttribute('type', 'file');
            input.setAttribute('accept', 'image/*');

            input.addEventListener('change', (e: Event) => {
              const target = e.target as HTMLInputElement;
              const file: File = (target.files as FileList)[0];

              const reader = new FileReader();
              reader.addEventListener('load', () => {
                // Note: Now we need to register the blob in TinyMCEs image blob registry.
                const id = 'blobid' + (new Date()).getTime();
                const blobCache = editorRef?.current?.editor?.editorUpload?.blobCache;
                const result = reader?.result as string;
                const base64 = result?.split(',')[1];
                if (blobCache) {
                  const blobInfo = blobCache?.create(id, file, base64);
                  blobCache?.add(blobInfo);
                  // call the callback and populate the Title field with the file name
                  cb(blobInfo.blobUri(), { title: file.name });
                }
              });
              reader.readAsDataURL(file);
            });
            input.click();
          },
          // images_upload_handler: handleImageUpload,
          content_css: 'editorCss',
        }}
      />
      {error && (
        <div className="absolute -bottom-5 text-error text-xs">
          {ElementUtils.renderError(error)}
        </div>
      )}
    </FormControl>
  );
}

EditorInline.defaultProps = {
  onChange: () => { },
  disabled: false,
  placeholder: '',
};

EditorInline.propTypes = {};

export default EditorInline;
